import { render, staticRenderFns } from "./JobThisWeekComponent.vue?vue&type=template&id=12953980&"
import script from "./JobThisWeekComponent.vue?vue&type=script&lang=js&"
export * from "./JobThisWeekComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports